var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-theme-provider',[_c('Loader'),_c('LoaderOpacity'),_c('LoarderCheck'),_c('ModalSaveSucess'),_c('ModalSendSucess'),_c('c-reset'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }